
import { useSparcAgentState } from './useSparcAgentState';
import { useSparcInitialization } from './useSparcInitialization';
import { useSparcOperations } from './useSparcOperations';
import { SparcConfig } from '@/services/agentic/sparcService';

interface UseSparcAgentProps {
  defaultConfig?: SparcConfig;
  autoInitialize?: boolean;
}

/**
 * Main hook for managing SPARC agent functionality
 */
export const useSparcAgent = (props?: UseSparcAgentProps) => {
  const { defaultConfig, autoInitialize = true } = props || {};
  
  // Get state management
  const state = useSparcAgentState(defaultConfig);
  
  // Get initialization functionality
  const { initAgent } = useSparcInitialization(
    state.config,
    autoInitialize,
    {
      setLoading: state.setLoading,
      setError: state.setError,
      setInitialized: state.setInitialized,
      setConfig: state.setConfig,
      setAvailableProviders: state.setAvailableProviders
    }
  );
  
  // Get operation functionality
  const operations = useSparcOperations({
    setLoading: state.setLoading,
    setError: state.setError,
    setAnalyzing: state.setAnalyzing,
    setModifying: state.setModifying,
    setExecuting: state.setExecuting,
    setSearching: state.setSearching,
    setAnalysisResult: state.setAnalysisResult,
    setModificationResult: state.setModificationResult,
    setExecutionResult: state.setExecutionResult,
    setSearchResult: state.setSearchResult,
    config: state.config,
    setConfig: state.setConfig
  });
  
  return {
    // State
    loading: state.loading,
    analyzing: state.analyzing,
    modifying: state.modifying,
    executing: state.executing,
    searching: state.searching,
    initialized: state.initialized,
    error: state.error,
    config: state.config,
    availableProviders: state.availableProviders,
    
    // Results
    analysisResult: state.analysisResult,
    modificationResult: state.modificationResult,
    executionResult: state.executionResult,
    searchResult: state.searchResult,
    
    // Actions
    initAgent,
    updateConfig: state.updateConfig,
    ...operations
  };
};

export default useSparcAgent;
